import { useMemo } from 'react';

import { groupMarketsBySector } from '@/entities/market';
import { useMarketsList } from '@/features/markets/api/marketsList.options';
import { useAppSelector } from '@/store/hooks';

export const useMarketsNavigationItems = () => {
  const tripTokenStatus = useAppSelector(state => state.tripToken.status);
  const { data } = useMarketsList(undefined, tripTokenStatus === 'fulfilled');
  const groupedMarkets = data?.groupedMarkets;
  const menuItems = useMemo(() => {
    return groupMarketsBySector(groupedMarkets ?? []);
  }, [groupedMarkets]);

  return { menuItems };
};
